import React, { useState, useEffect } from "react";
import DataTable from "examples/Tables/DataTable";
import CrudService from "services/cruds-service"; // Veri çekme servisi
import { useNavigate } from "react-router-dom";
import DashboardNavbar from "../../../../../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../../../../../examples/LayoutContainers/DashboardLayout";
import ImportExcel from "../../ImportExcel";
import * as XLSX from "xlsx";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip as ChartTooltip,
    Legend,
} from "chart.js";
import Footer from "../../../../../../examples/Footer";
import { appConfirm } from "components/AppDialog";


import { CrmRowActions, ListLink, ListPage, CrmActionButton, CrmNotice, ListTruncate } from "../shared/CrmUi";
import Add from "@mui/icons-material/Add";
import FileDownloadOutlined from "@mui/icons-material/FileDownloadOutlined";
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    ChartTooltip,
    Legend,
);

function GlobalAgentTable() {
    const [data, setData] = useState([]); // Backend'den gelen ham veriler
    const [tableData, setTableData] = useState([]); // Tabloya uygun hale getirilmiş veriler
    const [selectedRows, setSelectedRows] = useState([]); // Seçilen satırlar
    const [notification, setNotification] = useState({ value: false, text: "" });
    const navigate = useNavigate();

    // Backend'den veri çekme işlemi
    const fetchData = async () => {
        try {
            const response = await CrudService.getGlobalAgents();
            const normalizedData = response.data.map((item) => ({
                id: item.id,
                ...item.attributes,
            }));
            setData(normalizedData);
        } catch (error) {
            console.error("Error fetching globalAgents:", error);
            setNotification({
                value: true,
                text: "Failed to load Global Agents. Please try again later.",
            });
        }
    };

    // Component mount olunca çağır
    useEffect(() => {
        fetchData();
    }, []);



    const [salesRepOptions, setSalesRepOptions] = useState([]);

    useEffect(() => {
        const fetchSalesReps = async () => {
            try {
                const response = await CrudService.getUsers(); // Kullanıcıları çek
                const users = response.data.map((u) => ({
                    id: u.id,
                    name: u.attributes?.name || "Unknown",
                }));
                setSalesRepOptions(users);
            } catch (error) {
                console.error("Error fetching sales reps:", error);
            }
        };
        fetchSalesReps();
    }, []);
    function getCombinedCountries(globalAgent) {
        const gaCountries = Array.isArray(globalAgent.globalAgentCountry)
            ? globalAgent.globalAgentCountry
            : globalAgent.globalAgentCountry
                ? [globalAgent.globalAgentCountry]
                : [];

        const svcCountries = Array.isArray(globalAgent.servicesCountry)
            ? globalAgent.servicesCountry
            : globalAgent.servicesCountry
                ? [globalAgent.servicesCountry]
                : [];

        const combined = new Set([...gaCountries, ...svcCountries]);
        return Array.from(combined);
    }

    // Verileri tabloya uygun hale getiriyoruz
    const getRows = (data) => {
        return data.map((globalAgent) => {
            let salesRepDisplay = "-";

            if (Array.isArray(globalAgent.salesRep)) {
                const names = globalAgent.salesRep.map((id) => {
                    const match = salesRepOptions.find((rep) => {
                        const repId = rep.id || rep._id;
                        return repId?.toString() === id?.toString();
                    });
                    return match ? match.name : "-";
                });
                salesRepDisplay = names.join(", ");
            }

            return {
                id: globalAgent.id,
                globalAgentNo: globalAgent.globalAgentNo,
                name: (
                    <ListTruncate text={globalAgent.name || "—"} max={40} />
                ),
                paymentTerms: globalAgent.paymentTerms,
                globalAgentStatus: globalAgent.globalAgentStatus,
                globalAgentCountry: getCombinedCountries(globalAgent).join(", "),
                servicesPriority: Array.isArray(globalAgent.servicesPriority)
                    ? globalAgent.servicesPriority.join(", ")
                    : "",
                salesRep: salesRepDisplay,
                actions: (
                    <CrmRowActions onEdit={() => clickEditHandler(globalAgent.id)} editTitle="Edit Global Agent" onDelete={(e) => clickDeleteHandler(e, globalAgent.id)} deleteTitle="Delete Global Agent" />
                ),
            };
        });
    };

    useEffect(() => {
        if (data.length > 0) {
            setTableData(getRows(data)); // Veriyi tabloya uygun hale getir ve güncelle
        }
    }, [data, selectedRows]); // selectedRows'u da izleyerek tabloyu güncel tutuyoruz

    // Edit quotingTool button click handler
    const clickEditHandler = (id) => {
        navigate(`/global-agent/create-global-agent/details?id=${id}`); // ID'yi query parametre olarak gönderiyoruz
    };

    const clickDeleteHandler = async (e, id) => {
        try {
            if (!await appConfirm("Are you sure you want to delete this Global Agent?")) {
                return;
            }

            // Silme işlemi
            await CrudService.deleteGlobalAgent(id);

            // Local state'i güncelle
            const updatedData = data.filter((item) => item.id !== id);
            setData(updatedData); // `data` güncellendiği için tablo da otomatik güncellenecek

            setNotification({
                value: true,
                text: "Global Agent deleted successfully.",
            });

            // Mesajı 5 saniye sonra kaldır
            setTimeout(() => {
                setNotification({ value: false, text: "" });
            }, 5000);
        } catch (error) {
            console.error("Error deleting Global Agent:", error);

            setNotification({
                value: true,
                text: "Failed to delete Global Agent. Please try again later.",
            });

            // Mesajı 5 saniye sonra kaldır
            setTimeout(() => {
                setNotification({ value: false, text: "" });
            }, 5000);
        }
    };

    // Tablonun güncellenmesi
    useEffect(() => {
        setTableData(getRows(data)); // `data` değiştikçe tabloyu günceller
    }, [data]);






    const dataTableData = {
        columns: [
            {
                Header: () => (
                    <span style={{ fontWeight: "bold", fontSize: "14px" }}>Global Agent ID</span>
                ),
                accessor: "globalAgentNo",
                Cell: ({ row }) => (
                    <ListLink onClick={() => clickEditHandler(row.original.id)}>
                        {row.original.globalAgentNo || "No ID"}
                    </ListLink>
                ),
            },
            {
                Header: () => (
                    <span style={{ fontWeight: "bold", fontSize: "14px" }}>Global Agent</span>
                ),
                accessor: "name",
            },
            {
                Header: () => (
                    <span style={{ fontWeight: "bold", fontSize: "14px" }}>Payment Terms (days)</span>
                ),
                accessor: "paymentTerms",
            },
            {
                Header: () => (
                    <span style={{ fontWeight: "bold", fontSize: "14px" }}>Status</span>
                ),
                accessor: "globalAgentStatus",
            },
            {
                Header: () => (
                    <span style={{ fontWeight: "bold", fontSize: "14px" }}>HQ/Service Country</span>
                ),
                accessor: "globalAgentCountry",
            },
            {
                Header: () => (
                    <span style={{ fontWeight: "bold", fontSize: "14px" }}>Service</span>
                ),
                accessor: "servicesPriority",
            },
            {
                Header: () => (
                    <span style={{ fontWeight: "bold", fontSize: "14px" }}>Sales Rep</span>
                ),
                accessor: "salesRep",
            },
            {
                Header: () => (
                    <span style={{ fontWeight: "bold", fontSize: "14px" }}>Actions</span>
                ),
                accessor: "actions",
                disableSortBy: true,
            },
        ],
        rows: tableData,
    };


    const normalizeArray = (val) => {
        if (Array.isArray(val)) return val;
        if (val === null || val === undefined || val === "") return [];
        return [val];
    };

    const toComma = (val) => normalizeArray(val).join(", ");

    const getSalesRepNamesForExport = (salesRepIds) => {
        if (!Array.isArray(salesRepIds)) return "-";
        const names = salesRepIds.map((id) => {
            const match = salesRepOptions.find((rep) => {
                const repId = rep.id || rep._id;
                return repId?.toString() === id?.toString();
            });
            return match ? match.name : id; // isim yoksa id yaz
        });
        return names.join(", ");
    };
    const fetchAllGlobalAgents = async () => {
        const all = [];
        let page = 1;
        const pageSize = 200; // backend destekliyorsa
        while (true) {
            const res = await CrudService.getGlobalAgents({ page, pageSize });
            const rows = (res.data || []).map((item) => ({ id: item.id, ...item.attributes }));

            all.push(...rows);

            // Eğer backend meta ile toplam sayfa dönüyorsa burayı ona göre değiştir
            const meta = res.meta || res?.data?.meta;
            const hasNext =
                (meta?.pagination && page < meta.pagination.pageCount) ||
                rows.length === pageSize; // meta yoksa yaklaşık kontrol

            if (!hasNext) break;
            page += 1;
        }
        return all;
    };

    const handleExportExcel = async () => {
        try {
            // 1) tüm kayıtları çek
            const allData = await fetchAllGlobalAgents();

            // 2) excel satırları
            const exportRows = allData.map((ga) => ({
                name: ga.name || "",
                globalAgentCountry: toComma(ga.globalAgentCountry),
                servicesCountry: toComma(ga.servicesCountry),
                taxID: ga.taxID || "",
                taxOffice: ga.taxOffice || "",
                globalAgentTypes: toComma(ga.globalAgentTypes),
                salesRep: getSalesRepNamesForExport(ga.salesRep),
                phone: ga.phone || "",
                email: ga.email || "",
                paymentTerms: ga.paymentTerms ?? "",
                creditLimit: ga.creditLimit ?? "",
                globalAgentCategory: ga.globalAgentCategory || "",
                globalAgentStatus: ga.globalAgentStatus || "",
                serviceType: toComma(ga.serviceType),
                byTypeOfCollaboration: toComma(ga.byTypeOfCollaboration),
            }));

            const ws = XLSX.utils.json_to_sheet(exportRows);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "GlobalAgents");

            const fileName = `global_agents_all_${new Date().toISOString().slice(0, 10)}.xlsx`;
            XLSX.writeFile(wb, fileName);
        } catch (err) {
            console.error("Export failed:", err);
            setNotification({ value: true, text: "Export failed. Please try again." });
            setTimeout(() => setNotification({ value: false, text: "" }), 5000);
        }
    };



    const clickAddHandler = () => {
        navigate("/global-agent/create-global-agent/details"); // Yeni shipment ekleme sayfasına yönlendiriyoruz
    };
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <ListPage
                title="Global Partners"
                subtitle="Overseas agents and partners by country and service. Import from Excel, export the list or open a partner to edit it."
                actions={
                    <>
                        <ImportExcel onUploadSuccess={fetchData} />
                        <CrmActionButton variant="secondary" icon={<FileDownloadOutlined />} onClick={handleExportExcel}>
                            Export
                        </CrmActionButton>
                        <CrmActionButton icon={<Add />} onClick={clickAddHandler}>
                            New Global Partner
                        </CrmActionButton>
                    </>
                }
                notice={notification.value && <CrmNotice tone="blue">{notification.text}</CrmNotice>}
                tableTitle="Global partner list"
                tableSummary={`${dataTableData.rows.length} global partners`}
            >
                <DataTable table={dataTableData} canSearch />
            </ListPage>
            <Footer />
        </DashboardLayout>
    );

}

export default GlobalAgentTable;
